import { locationIdFormat } from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import { storageLocationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const BinSearchResultSchema = z.object({
  storageLocationId: storageLocationIdFormat.schema,
  binName: z.string(),
  locationId: locationIdFormat.schema,
  locationName: z.string(),
});
export type BinSearchResult = z.infer<typeof BinSearchResultSchema>;

export const searchBins = {
  name: "searchBins" as const,
  input: z.object({
    productId: productIdFormat.schema.optional(),
    locationId: locationIdFormat.schema.optional(),
    search: z.string().optional(),
  }),
  output: z.object({ bins: z.array(BinSearchResultSchema) }),
};
